module.exports = __webpack_public_path__ + "img/icon_header_user.1e574f99.svg";